/**
 * @generated SignedSource<<ad4f57055b1a5a20934f4cdc99db024f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Chain = "ARBITRUM" | "ETHEREUM" | "ETHEREUM_GOERLI" | "OPTIMISM" | "POLYGON" | "%future added value";
export type Currency = "ETH" | "USD" | "%future added value";
export type TopTokenQuery$variables = {
  page: number;
};
export type TopTokenQuery$data = {
  readonly topTokenProjects: ReadonlyArray<{
    readonly markets: ReadonlyArray<{
      readonly fullyDilutedMarketCap: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly marketCap: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly price: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly volume1D: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly volume1H: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly volume1M: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly volume1W: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
      readonly volume1Y: {
        readonly currency: Currency | null;
        readonly value: number | null;
      } | null;
    } | null> | null;
    readonly name: string | null;
    readonly tokens: ReadonlyArray<{
      readonly address: string | null;
      readonly chain: Chain;
      readonly symbol: string | null;
    }>;
  } | null> | null;
};
export type TopTokenQuery = {
  response: TopTokenQuery$data;
  variables: TopTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "page"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "currency",
    "value": "USD"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "MARKET_CAP"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Literal",
    "name": "pageSize",
    "value": 50
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chain",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "currencies",
    "value": [
      "USD"
    ]
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = [
  {
    "kind": "Literal",
    "name": "duration",
    "value": "HOUR"
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "duration",
    "value": "DAY"
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "duration",
    "value": "WEEK"
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "duration",
    "value": "MONTH"
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "duration",
    "value": "YEAR"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopTokenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TokenProject",
        "kind": "LinkedField",
        "name": "topTokenProjects",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Token",
            "kind": "LinkedField",
            "name": "tokens",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TokenProjectMarket",
            "kind": "LinkedField",
            "name": "markets",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "marketCap",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "fullyDilutedMarketCap",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": "volume1H",
                "args": (v10/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "volume(duration:\"HOUR\")"
              },
              {
                "alias": "volume1D",
                "args": (v11/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "volume(duration:\"DAY\")"
              },
              {
                "alias": "volume1W",
                "args": (v12/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "volume(duration:\"WEEK\")"
              },
              {
                "alias": "volume1M",
                "args": (v13/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "volume(duration:\"MONTH\")"
              },
              {
                "alias": "volume1Y",
                "args": (v14/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "volume(duration:\"YEAR\")"
              }
            ],
            "storageKey": "markets(currencies:[\"USD\"])"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopTokenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TokenProject",
        "kind": "LinkedField",
        "name": "topTokenProjects",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Token",
            "kind": "LinkedField",
            "name": "tokens",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "TokenProjectMarket",
            "kind": "LinkedField",
            "name": "markets",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "marketCap",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "fullyDilutedMarketCap",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": null
              },
              {
                "alias": "volume1H",
                "args": (v10/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": "volume(duration:\"HOUR\")"
              },
              {
                "alias": "volume1D",
                "args": (v11/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": "volume(duration:\"DAY\")"
              },
              {
                "alias": "volume1W",
                "args": (v12/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": "volume(duration:\"WEEK\")"
              },
              {
                "alias": "volume1M",
                "args": (v13/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": "volume(duration:\"MONTH\")"
              },
              {
                "alias": "volume1Y",
                "args": (v14/*: any*/),
                "concreteType": "Amount",
                "kind": "LinkedField",
                "name": "volume",
                "plural": false,
                "selections": (v16/*: any*/),
                "storageKey": "volume(duration:\"YEAR\")"
              },
              (v15/*: any*/)
            ],
            "storageKey": "markets(currencies:[\"USD\"])"
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f26d4e82d2da59f2b7bf9d3a2c214a4",
    "id": null,
    "metadata": {},
    "name": "TopTokenQuery",
    "operationKind": "query",
    "text": "query TopTokenQuery(\n  $page: Int!\n) {\n  topTokenProjects(orderBy: MARKET_CAP, pageSize: 50, currency: USD, page: $page) {\n    name\n    tokens {\n      chain\n      address\n      symbol\n      id\n    }\n    markets(currencies: [USD]) {\n      price {\n        value\n        currency\n        id\n      }\n      marketCap {\n        value\n        currency\n        id\n      }\n      fullyDilutedMarketCap {\n        value\n        currency\n        id\n      }\n      volume1H: volume(duration: HOUR) {\n        value\n        currency\n        id\n      }\n      volume1D: volume(duration: DAY) {\n        value\n        currency\n        id\n      }\n      volume1W: volume(duration: WEEK) {\n        value\n        currency\n        id\n      }\n      volume1M: volume(duration: MONTH) {\n        value\n        currency\n        id\n      }\n      volume1Y: volume(duration: YEAR) {\n        value\n        currency\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a406185ac1501b6f968e02677f03349";

export default node;
